import { useEssentials } from 'hooks/utils/useEssentials'
import { StoreFulfillmentShipRGD } from './store-fulfillment-ship-rgd'
import { isStore } from 'utils/location'
import { StoreFulfillmentShipStore } from './store-fulfillment-store'

export const StoreFulfillmentShip = () => {
    const { currentLocation } = useEssentials()
    if (!isStore(currentLocation)) {
        return <StoreFulfillmentShipRGD />
    } else {
        return <StoreFulfillmentShipStore />
    }
}
